import { ListColumn, ListDataColumn } from "../ListColumn";
import { MeddraListView } from "./MeddraListView";

export class HLGTListView extends MeddraListView{

    constructor(items: any) {
        let itemsWithChecked = items;
        if (itemsWithChecked && itemsWithChecked.length>0) {
            itemsWithChecked = items.map((info: any) => ({checked: false, ...info}));
        }

        const itemFinderArrayColumns: ListColumn[] = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("HLGT Code", ListDataColumn.TEXT, "code"),
            new ListColumn("HLGT Name", ListDataColumn.TEXT, "name")
        ];
        const itemFinderTreeColumns: ListColumn[] = [
            new ListColumn("HLGT Code", ListDataColumn.TEXT, "code"),
            new ListColumn("HLGT Name", ListDataColumn.TEXT, "name")
        ];

        super(itemsWithChecked,  itemFinderArrayColumns, itemFinderTreeColumns);
    }
}